<template>
  <div>
    <div v-for="(item, i) in content" :key="i" class="flex m-2">
      <div class="w-1/2 td-left p-2 flex items-center justify-left pl-10 border-gray-800 border">
        {{ item.title }}
      </div>
      <div class="w-1/2 td-right p-2 flex items-center border-gray-800 border">
        {{ item.body }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: [
        {
          title: "Vaccinated Persons",
          body: "You will need to be fully vaccinated and present your vaccination card and valid government issued ID.and valid government issued ID",
        },
        {
          title: "Health Declaration",
          body: "You will need to fill-out a health declaration form. If you present symptoms of Covid-19, you will not be allowed in the building.",
        },
        {
          title: "No Companions",
          body: "Companions will not be allowed inside the building to observe social distancing.",
        },
        {
          title: "Face Mask",
          body: "You will need to wear your face mask at all times while on the premises.",
        },
        {
          title: "Declaration of Concerns",
          body: "There may be delays in accommodating you should you have further concerns or requests that are not declared in your appointment request.",
        },
        {
          title: "Authorized Representative",
          body: "If you will send a representative on your behalf, he will need to bring the following (1) signed authorization clearly indicating his level of authority, (2) a photocopy of your valid photo-bearing government issued ID, (3) the representative’s original valid photo-bearing government issued ID.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.td-left{
  background: #E9967A;
}
.td-right{
  background: #FAEBD7;
}
</style>